const findProp = (prop, obj) => {
  if (typeof obj !== 'object') {
    return null;
  }

  if (obj === null) {
    return null;
  }

  if (obj === undefined) {
    return null;
  }

  if (typeof prop !== 'string') {
    throw Error('Property has to be a string! ');
  }

  let propValue = null;

  if (obj[prop]) {
    return obj[prop];
  }
 
  for (let key in obj) {
    propValue = findProp(prop, obj[key]);
    if (propValue !== null) {
      break;
    }
  }

  return propValue;
};

const findDeepProp = (props, obj) => {
  if (typeof props !== 'string' && !(props instanceof Array)) {
    throw Error('Property has to be a string or array!');
  }

  if (typeof props === 'string') {
    let split = props.split('.');
    return findDeepProp(split, obj);
  }

  const element = props.shift();

  let propValue = findProp(element, obj);
  if (propValue !== null && props.length > 0) {
    propValue = findDeepProp(props, propValue);
  }

  return propValue;
};

const arrayToObject = (arr, keyField) =>
  Object.assign({}, ...arr.map(item => ({ [item[keyField]]: item })));

export {
  arrayToObject,
  findDeepProp,
};

export default {
  install(vue, { store }) {
    vue.prototype.$helpers = {
      arrayToObject,
      findDeepProp,
    };
    store.$helpers = vue.prototype.$helpers;
  },
};
